export default __webpack_public_path__ + "static/media/creativityFestival2026Pic.69cbafb6.png";